export function narrowError<T>(check: (value: T) => string | null) {
  return (value: T, ctx: { mustBe: (description: string) => false }): boolean => {
    const error = check(value);
    return error === null || ctx.mustBe(error);
  };
}
